import { useState, useEffect } from "react";
import { doc, getDoc, getFirestore } from "firebase/firestore";

export const useEnterpriseData = (enterpriseId) => {
  const [enterprise, setEnterprise] = useState(null);
  const [loadingEnterprise, setLoading] = useState(true);

  useEffect(() => {
    const fetchEnterprise = async () => {
      if (!enterpriseId) {
        setLoading(false);
        return;
      }

      const db = getFirestore();
      const ref = doc(db, "enterprises", enterpriseId);
      const snap = await getDoc(ref);

      if (snap.exists()) {
        setEnterprise({ id: snap.id, ...snap.data() });
      } else {
        console.warn("Enterprise não encontrada.");
      }

      setLoading(false);
    };

    fetchEnterprise();
  }, [enterpriseId]);

  return { enterprise, loadingEnterprise };
};
